__turbopack_context__.v({
  "closeButton": "MobilePopupLayout-module-scss-module__-rjZ8q__closeButton",
  "container": "MobilePopupLayout-module-scss-module__-rjZ8q__container",
  "header": "MobilePopupLayout-module-scss-module__-rjZ8q__header",
  "title": "MobilePopupLayout-module-scss-module__-rjZ8q__title",
});
